<script>
    import { onMount } from "svelte";
    import { getJiraStatus } from "../http";

    let status = "loading";
    let message = "Sprawdzanie połączenia...";
    let responseTime = null;
    let config = null;
    let isLoading = false;
    let showDetails = false;

    const statusColors = {
        ok: "is-success",
        warning: "is-warning",
        error: "is-danger",
        loading: "is-light"
    };

    const statusLabels = {
        ok: "Jira połączona",
        warning: "Jira z ostrzeżeniem",
        error: "Jira niedostępna",
        loading: "Jira — sprawdzam"
    };

    const statusIcons = {
        ok: "✓",
        warning: "⚠",
        error: "✗",
        loading: "⟳"
    };

    async function checkConnection() {
        isLoading = true;
        status = "loading";
        message = "Sprawdzanie połączenia...";

        try {
            const result = await getJiraStatus();
            status = result.status;
            message = result.message;
            responseTime = result.response_time_ms;
            config = result.config;
        } catch (error) {
            status = "error";
            message = "Nie można sprawdzić statusu połączenia";
            console.error("Jira status check failed:", error);
        } finally {
            isLoading = false;
        }
    }

    function toggleDetails() {
        showDetails = !showDetails;
    }

    onMount(() => {
        checkConnection();
    });
</script>

<div class="jira-status-container">
    <div class="dropdown" class:is-active={showDetails}>
        <div class="dropdown-trigger">
            <div class="jira-pill">
                <button
                    class="jira-pill__status"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    on:click={toggleDetails}
                    title={message}>
                    <span class="jira-dot {statusColors[status]}" class:rotating={isLoading}></span>
                    <span>{statusLabels[status]}</span>
                </button>
                <button
                    class="jira-pill__refresh"
                    on:click={checkConnection}
                    disabled={isLoading}
                    title="Odśwież status"
                    aria-label="Odśwież status Jiry">
                    <span class:rotating={isLoading}>⟳</span>
                </button>
            </div>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
                <div class="dropdown-item">
                    <div class="content">
                        <p class="heading">Status połączenia</p>
                        <p class="title is-6">
                            <span class="tag {statusColors[status]}">{status.toUpperCase()}</span>
                        </p>
                        <p>{message}</p>
                        {#if responseTime !== null}
                            <p class="has-text-grey-light is-size-7">
                                Czas odpowiedzi: {responseTime}ms
                            </p>
                        {/if}
                    </div>
                </div>
                <hr class="dropdown-divider">
                {#if config}
                    <div class="dropdown-item">
                        <div class="content">
                            <p class="heading">Konfiguracja</p>
                            <table class="table is-narrow is-size-7">
                                <tbody>
                                    <tr>
                                        <td><strong>URL:</strong></td>
                                        <td class="url-cell">{config.jira_url}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Email:</strong></td>
                                        <td>{config.jira_auth_mail}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Auth ID:</strong></td>
                                        <td>{config.jira_auth_id}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .jira-status-container {
        display: inline-block;
    }

    .rotating {
        display: inline-block;
        animation: rotate 1s linear infinite;
    }

    @keyframes rotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    .dropdown-menu {
        min-width: 350px;
    }

    .url-cell {
        word-break: break-all;
        max-width: 250px;
    }

    .table {
        background-color: transparent;
        width: 100%;
    }

    .table td {
        border: none;
        padding: 0.25rem 0.5rem;
    }

    .content p {
        margin-bottom: 0.5rem;
    }

    .dropdown-content {
        padding: 0.5rem 0;
    }

    .dropdown-item {
        padding: 0.5rem 1rem;
    }

    .buttons {
        margin-bottom: 0;
    }
</style>

